module.exports = __webpack_public_path__ + "img/juxueIcon1.3012e907.png";